module.exports = __webpack_public_path__ + "img/about-1.c13048d1.png";